import { render, staticRenderFns } from "./callmodals.vue?vue&type=template&id=25d841ea&scoped=true"
import script from "./callmodals.vue?vue&type=script&lang=js"
export * from "./callmodals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d841ea",
  null
  
)

export default component.exports